var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('Container',{attrs:{"padding":"60px 0","breakpoints":{
      xs: 0,
      sm: 480,
      md: 768,
      lg: 1024,
      xl: 1280,
      xxl: 1440,
    }}},[_c('div',{staticClass:"profile-wrapper"},[_c('div',{staticClass:"profile-navbar-wrapper"},[_c('div',{staticClass:"profile-navbar-side",attrs:{"data-aos":"fade-out"}},[_c('nav',{staticClass:"profile-navbar"},[_c('ul',{staticClass:"profile-navbar-menu"},_vm._l((_vm.navItems),function(item){return _c('li',{key:item.name,staticClass:"profile-navbar-item"},[_c('router-link',{staticClass:"profile-navbar-link",attrs:{"to":item.path,"active-class":"profile-active-link","exact":item.path === '/profile'}},[_c('TextField',{attrs:{"tag":"span","size":"18","weight":"500","color":"#262626","hoverColor":"#0056b3","enableHover":true}},[_vm._v(" "+_vm._s(_vm.$t(`profile.${[item.name]}`))+" ")])],1)],1)}),0)])]),_c('router-view')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }